import Axios, { AxiosPromise } from 'axios'
import { RequestConfig } from '@fe/common/axiosConfig'

export interface VopVerifyRequest {
  iban: string
  name: string
  bic: string
  account_settings_id: number
}

export interface VopVerifyResponse {
  success: boolean
  party_name_match: 'MTCH' | 'NMTC' | 'CMTC' | 'NOAP' | string
  matched_name: string | null
}

export interface VopVerifyApiResponse {
  code: number
  status: string
  message: string
  data: VopVerifyResponse
}

export class VopApi {
  static verify(
    data: VopVerifyRequest,
    config?: RequestConfig
  ): AxiosPromise<VopVerifyApiResponse> {
    return Axios({
      ...config,
      url: `/vop/verify`,
      method: 'POST',
      data,
    })
  }
}
